export default "__VITE_ASSET__BGMdsRtj__"